import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  Attribute,
  Priority,
  Status,
  OrderType,
} from "../master-data/master-data.model";
import { Chain } from "../chains/chains.model";
import { NEW_UI_FORM_FIELD_DEFAULTS } from "../shared/styles/new-ui-form-field";

@Component({
    selector: "app-form-permissions-item-edit",
    templateUrl: "./item-edit.component.html",
    styleUrls: ["./item-edit.component.scss"],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemEditComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<ItemEditComponent>>(MatDialogRef);
  data = inject<OrderType | Priority | Status | Chain | Attribute>(MAT_DIALOG_DATA);

  form: FormGroup;

  editMode = false;
  title = "";

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      uuid: [null],
      name: [null, [Validators.required]],
      externalId: [null],
    });

    if (this.data instanceof OrderType) {
      this.title = "Type";
    } else if (this.data instanceof Status) {
      this.title = "Status";
      this.form.addControl("metaId", new FormControl("", Validators.required));
    } else if (this.data instanceof Priority) {
      this.title = "Priority";
      this.form.addControl("metaId", new FormControl("", Validators.required));
    } else if (this.data instanceof Chain) {
      this.title = "Chain";
    } else if (this.data instanceof Attribute) {
      this.title = "User Attribute";
      this.form.addControl(
        "renderTag",
        new FormControl("", Validators.required)
      );
    }

    if (this.data.uuid != null) {
      this.editMode = true;
      this.patchValues();
    }
  }

  private patchValues() {
    this.form.patchValue({
      uuid: this.data.uuid,
      name: this.data.name,
      externalId: this.data.externalId,
    });
    if (this.data instanceof Status || this.data instanceof Priority) {
      this.form.patchValue({
        metaId: this.data.metaId,
      });
    }
    if (this.data instanceof Attribute) {
      this.form.patchValue({
        renderTag: this.data.renderTag,
      });
    }
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(this.form.value);
  }
}
